import { Complete } from "./components/Complete";

export const PickupCompletePage = () => {
    return (
        <>
            <Complete />
        </>
    )
}